import { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { privacyApi } from '../../../services/privacyApi';
import { logger } from '../../../utils/logger';
import { AlertIcon } from './Icons';

export default function DangerZoneCard() {
    const { t } = useTranslation();
    const [confirmText, setConfirmText] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleDeleteAccount = async () => {
        if (confirmText.toUpperCase() !== t('privacy.confirm_word')) return;

        setLoading(true);
        try {
            await privacyApi.deleteAccount();
            setSuccess(true);
            setTimeout(() => {
                window.location.href = '/';
            }, 3000);
        } catch (err) {
            logger.error('Failed to delete account', err);
            setLoading(false);
            alert(t('privacy.failed_deletion'));
        }
    };

    if (success) {
        return (
            <div className="privacy-card danger-zone success">
                <div className="success-content">
                    <AlertIcon size={32} color="#22c55e" />
                    <h3>{t('privacy.deletion_scheduled')}</h3>
                    <p>{t('privacy.deletion_scheduled_desc')}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="privacy-card danger-zone">
            <div className="card-header">
                <h3>{t('privacy.danger_zone')}</h3>
            </div>
            <p className="card-subtitle">{t('privacy.erasure_request')}</p>

            <div className="danger-notice-box">
                <AlertIcon size={18} color="#ef4444" />
                <div className="notice-text">
                    <strong>{t('privacy.grace_period')}</strong>
                    <ul>
                        <li>{t('privacy.retain_invoice')}</li>
                        <li>{t('privacy.purge_notice')}</li>
                    </ul>
                </div>
            </div>

            <div className="confirm-delete-action">
                <p>
                    <Trans i18nKey="privacy.type_confirm" values={{ confirm: t('privacy.confirm_word') }}>
                        Type <strong>{t('privacy.confirm_word')}</strong> to confirm:
                    </Trans>
                </p>
                <div className="confirm-input-row">
                    <input
                        type="text"
                        value={confirmText}
                        onChange={(e) => setConfirmText(e.target.value)}
                        placeholder={t('privacy.placeholder_confirm', { confirm: t('privacy.confirm_word') })}
                        disabled={loading}
                    />
                    <button
                        className="btn-danger-solid"
                        disabled={confirmText.toUpperCase() !== t('privacy.confirm_word') || loading}
                        onClick={handleDeleteAccount}
                    >
                        {loading ? '...' : t('privacy.erase_account')}
                    </button>
                </div>
            </div>
        </div>
    );
}
